export const knownTrackTypes = [
  'track/onPatrol',
  'track/onDuty',
  'track/onFootPatrol',
  'track/onVehiclePatrol',
  'track/onAirPatrol',
  'track/onHumanSpoor',
  'track/onAnimalSpoor',
  'track/onSafari',
  'track/onCensus',
  'track/onFenceInspection',
  'track/onK9Patrol',
  'track/onPerimeterTrack',
  'track/onSearch',
  'track/onSnareSweep',
  'track/onBoatPatrol',
  'track/onDronePatrol',
  'track/onFastResponse',
  'track/onTraining',
  'track/onBikePatrol',
  'track/vehicleTracker',
  'track/undefined'
];
